(function() {
    'use strict';

    angular
        .module('portalApp')
        .factory('ModelEquationSearch', ModelEquationSearch);

    ModelEquationSearch.$inject = ['$resource'];

    function ModelEquationSearch($resource) {
        var resourceUrl =  'api/_search/model-equations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
